<template>

<div id="back">
  <button @click="$router.go(-1)"><font-awesome-icon :icon="['fas', 'reply']" /> Back</button>
</div>

</template>


<script>

export default { 
  name: "BackComponent",
}

</script>



<style scoped lang="scss">

#back {
  @include flex-center;
  justify-content: flex-start;
  width: 100%;
  padding: 30px 50px 30px 30px;
}
  #back .fa-reply {
    padding-right: 4px;
  }
  #back button {
    @include font-11;
    @include button-styles;
    color: black;
    font-weight: bold;
    padding: 2px 8px 2px 0;
    margin-right: 10px;
  }
    #database-object-container #back,
    #partner-profile-container #back {
      padding-left: 0;
    }
    #partners-options-container #back {
      width: auto;
      padding-left: 0;
    }

@media only screen and (max-width: 599px) {
  #back {
    padding: 0 0 30px 0;
  }
    #database-object-container #back,
    #partner-profile-container #back,
    #partners-options-container #back {
      padding-top: 30px;
    }
    #timeline-results-wrapper #back {
      padding: 30px;
    }
}

@media only screen and (max-width: 399px) {
  #partners-options-container #back {
    padding-top: 30px;
    padding-bottom: 0;
  }
}

</style>